/** Ambient films only. No cart or product logic. Handles Shopify section reloads. */
class ApoAmbientVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.button = this.querySelector('button');
    if (!this.video || !this.button) return;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.manualPause = false;
    this.inView = false;
    this.button.hidden = false;
    this.video.muted = true;
    this.sync = () => {
      const playing = !this.video.paused;
      this.button.setAttribute('aria-pressed', String(playing));
      this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
    };
    this.play = () => this.video.play().catch(this.sync);
    this.button.addEventListener('click', () => {
      if (this.video.paused) { this.manualPause = false; this.play(); }
      else { this.manualPause = true; this.video.pause(); }
    }, options);
    this.video.addEventListener('play', this.sync, options);
    this.video.addEventListener('pause', this.sync, options);
    this.update = () => {
      if (!this.inView || document.hidden || this.motion.matches || navigator.connection?.saveData || this.manualPause) this.video.pause();
      else this.play();
    };
    document.addEventListener('visibilitychange', this.update, options);
    this.motion.addEventListener('change', this.update, options);
    this.observer = new IntersectionObserver(entries => {
      this.inView = entries[0].isIntersecting;
      this.update();
    }, { threshold: .25 });
    this.observer.observe(this);
    this.sync();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
    this.video?.pause();
  }
}
if (!customElements.get('apo-ambient-video')) customElements.define('apo-ambient-video', ApoAmbientVideo);
